export default {"src":"/hedera/_next/static/media/hedera_dark.bbe07d1d.svg","height":10,"width":10};